import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Button } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import { Row, Col, ListGroup, Image, Card } from 'react-bootstrap';
import Message from '../components/Message';
import Loader from '../components/Loader';
import { useTranslation } from 'react-i18next';
import { useGetOrderDetailsQuery, useRegisterClicToPayOrderMutation } from '../slices/ordersApiSlice';
import { getImageUrl } from '../utils/imageUtils'; // ✅ Import de l'utilitaire

const OrderScreenClicToPay = () => {
  const { id: orderId } = useParams();

  const {
    data: order,
    isLoading,
    error,
  } = useGetOrderDetailsQuery(orderId);

  const [registerClicToPayOrder, { isLoading: isRegistering }] = 
    useRegisterClicToPayOrderMutation();

  const { deviseInfo } = useSelector((state) => state.devise);
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir().toLowerCase() === 'rtl';

  const startClicToPay = async () => {
    //console.log('🔄 startClicToPay called');
    
    if (!order) {
      console.error('❌ Order data not loaded');
      return;
    }

   // console.log('📦 Order data:', {
     // id: order._id,
     // totalPrice: order.totalPrice,
     // paymentMethod: order.paymentMethod
   // });

    try {
      //console.log('🚀 Calling registerClicToPayOrder mutation...');
      
      const res = await registerClicToPayOrder({
        orderId: order._id,
        amount: order.totalPrice,
      }).unwrap();

      //console.log('✅ API Response:', res);

      if (res.success && res.formUrl) {
        //console.log('🔗 Redirecting to:', res.formUrl);
        window.location.href = res.formUrl;
      } else {
        console.error('❌ API returned error:', res);
        toast.error(res.message || 'Erreur lors de la création du paiement');
      }
    } catch (err) {
      console.error('❌ Error in startClicToPay:', err);
      console.error('Error details:', err.data);
      toast.error(err?.data?.message || err.error || 'Erreur inconnue');
    }
  };

  return isLoading ? (
    <Loader />
  ) : error ? (
    <Message variant='danger'>{error}</Message>
  ) : (
    <>
      <h1>Commande {order._id}</h1>
      <Row>
        <Col md={8}>
          <ListGroup variant='flush'>
            <ListGroup.Item dir={isRTL ? 'rtl' : 'ltr'}>
              <h2>{t('orders')}</h2>
              <p>
                <strong>{t('name')} : </strong>{' '}
                {order.shippingAddress.namePrename}
              </p>
              <p>
                <strong> {t('email')} : </strong>{' '}
                <a href={`mailto:${order.shippingAddress.mail}`}>
                  {order.shippingAddress.mail}
                </a>
              </p>
              <p>
                <strong>{t('address')} </strong>
                {order.shippingAddress.adress}
              </p>
              <p>
                <strong>{t('phonenumber')} : </strong>
                {order.shippingAddress.tel}
              </p>
            </ListGroup.Item>

            <ListGroup.Item dir={isRTL ? 'rtl' : 'ltr'}>
              <h2>{t('mode')}</h2>
              <Col>
                <p>
                  <strong>{t('mode')} : </strong>
                  {order.paymentMethod}
                </p>
              </Col>
              <Col>
                <strong>{t('devise')} : </strong>
                {deviseInfo}
              </Col>
              {order.isPaid ? (
                <Message variant='success'>Payé le {order.paidAt}</Message>
              ) : (
                <Message variant='danger'>N'est pas payé</Message>
              )}
            </ListGroup.Item>

            <ListGroup.Item>
              <h2>{t('ordsum')}</h2>
              {order.orderItems.length === 0 ? (
                <Message>{t('emptycart')}</Message>
              ) : (
                <ListGroup variant='flush'>
                  {order.orderItems.map((item, index) => (
                    <ListGroup.Item key={index}>
                      <Row>
                        <Col md={1}>
                          {/* ✅ CORRECTION : Utiliser getImageUrl pour l'image de commande */}
                          <Image
                            src={getImageUrl(item.image)}
                            alt={item.name}
                            fluid
                            rounded
                            onError={(e) => {
                              e.target.src = '/images/placeholder.jpg';
                            }}
                          />
                        </Col>
                        <Col>
                          <Link to={`/product/${item.product}`}>
                            {item.name}
                          </Link>
                        </Col>

                        {deviseInfo === 'TND' && (
                          <Col md={5}>
                            {t('Price')} {' : '}
                            {item.qty} x {item.price} = {item.qty * item.price}{' '}
                            {deviseInfo}
                          </Col>
                        )}
                        {deviseInfo === 'EUR' && (
                          <Col md={5}>
                            {t('Price')}
                            {item.qty} x {item.priceEur} ={' '}
                            {item.qty * item.priceEur} {deviseInfo}
                          </Col>
                        )}
                        {deviseInfo === 'USD' && (
                          <Col md={5}>
                            {t('Price')}
                            {item.qty} x {item.priceDol} ={' '}
                            {item.qty * item.priceDol} {deviseInfo}
                          </Col>
                        )}
                      </Row>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              )}
            </ListGroup.Item>
          </ListGroup>
        </Col>
        <Col md={4}>
          <Card>
            <ListGroup variant='flush'>
              <ListGroup.Item>
                <h2 dir={isRTL ? 'rtl' : 'ltr'}>{t('ordsum')} </h2>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>{t('Price')} </Col>
                  {deviseInfo === 'TND' && (
                    <Col>
                      <strong>
                        {order.itemsPrice} {deviseInfo}
                      </strong>
                    </Col>
                  )}
                  {deviseInfo === 'EUR' && (
                    <Col>
                      <strong>
                        {order.itemsPriceEur} {deviseInfo}
                      </strong>
                    </Col>
                  )}
                  {deviseInfo === 'USD' && (
                    <Col>
                      <strong>
                        {order.itemsPriceDol} {deviseInfo}
                      </strong>
                    </Col>
                  )}
                </Row>
              </ListGroup.Item>

              {!order.isPaid && (
                <ListGroup.Item>
                  {deviseInfo === 'TND' ? (
                    <Button
                      type='button'
                      className='btn-block'
                      onClick={startClicToPay}
                      disabled={isRegistering}
                    >
                      Payer {order.totalPrice} {deviseInfo} avec ClicToPay
                    </Button>
                  ) : (
                    <h6>La devise de paiement doit être en dinar Tunisien</h6>
                  )}
                </ListGroup.Item>
              )}
            </ListGroup>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default OrderScreenClicToPay;